/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData';
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQ.js.map